const pageType = (document.querySelector('#pageType') != null);
(function () {
  if (pageType) {
    const navButtons = document.querySelectorAll('nav.k p'),
          typeImages = document.querySelectorAll('.plan-wrap .img-box.k .img'),
          defaultIcons = document.querySelectorAll('.icons .icon.v'),
          navButtons_Array = Array.from(navButtons);

    navButtons.forEach(navButton => {
      navButton.addEventListener('click', (e) => {
        var tabIndex = navButtons_Array.findIndex(list => list === e.target);
        tabSelect(tabIndex);
      });
    });
    
    function tabSelect(index) {
      navButtons.forEach((navButton) => {
        navButton.classList.remove('active');
      })
      typeImages.forEach((typeImage) => {
        typeImage.classList.remove('active');
      })
      defaultIcons.forEach((defaultIcon) => {
        defaultIcon.classList.remove('d');
        index == 1 ? defaultIcon.classList.add('d'): '';
      })
      navButtons[index].classList.add('active');
      typeImages[index].classList.add('active');
    }
  }
})();